import { z } from "zod";
import { DocumentSchema } from "./base.schema";

/**
 * Chat conversation record schema for fitties dating app
 * Represents a conversation between two matched users
 */
export const ChatSchema = DocumentSchema.extend({
  /** Timestamp when the chat was created */
  created_time: z.date().optional().describe("When the chat was created"),

  /** Both users participating in this chat */
  participant_uids: z.array(z.string()).optional().describe("User IDs participating in the chat"),

  /** Text content of the most recent message */
  last_message_text: z.string().optional().describe("Content of the last message sent"),

  /** Timestamp when the last message was sent */
  last_message_sent_timestamp: z.date().optional().describe("When the last message was sent"),

  /** Users who have seen the last message */
  last_message_seen_by_uids: z.array(z.string()).optional().describe("User IDs who have read the last message"),

  /** User who sent the last message */
  last_message_sent_by_uid: z.string().optional().describe("User ID who sent the last message"),

  /** Display names of users in the chat */
  participant_display_names: z.array(z.string()).optional().describe("Display names of chat participants"),

  /** Whether this chat has been blocked by either user */
  is_blocked: z.boolean().optional().describe("Whether the chat is blocked"),

  /** Reference to the last chat message document */
  last_chat_message_id: z.string().optional().describe("ID of the last message document"),
});

export type Chat = z.infer<typeof ChatSchema>;
